import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Spinner } from 'UI';
import { Button } from '@haldor/ui';

var WizardQuestion = /*#__PURE__*/function (_Component) {
  _inherits(WizardQuestion, _Component);

  var _super = _createSuper(WizardQuestion);

  function WizardQuestion() {
    _classCallCheck(this, WizardQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(WizardQuestion, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.625rem'
        },
        dangerouslySetInnerHTML: {
          __html: this.props.text
        }
      }), /*#__PURE__*/React.createElement("div", null, this.props.buttons.map(function (button, i) {
        var props = _objectSpread({}, button);

        delete props.isLoading;
        delete props.value;
        return /*#__PURE__*/React.createElement(Button, _extends({
          style: {
            marginRight: '1.3rem'
          },
          key: i
        }, props), button.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
          size: "small"
        }) : null, button.value);
      })));
    }
  }]);

  return WizardQuestion;
}(Component);

export default WizardQuestion;